export const StepIndicator: React.FC<{
  currentStep: number;
  steps: string[];
}> = ({ currentStep, steps }) => {
  return (
    <div className="flex items-center space-x-4 mb-8">
      {steps.map((step, index) => {
        const stepNumber = index + 1;
        const isActive = stepNumber === currentStep;
        const isCompleted = stepNumber < currentStep;
        
        return (
          <div key={step} className="flex items-center">
            <div
              className={`
                w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium
                ${isActive ? 'bg-blue-600 text-white' : 
                  isCompleted ? 'bg-blue-100 text-blue-600' : 'bg-gray-200 text-gray-500'}
              `}
            >
              {stepNumber}
            </div>
            <span className={`ml-2 text-sm ${isActive ? 'text-blue-600 font-medium' : 'text-gray-500'}`}>
              {step}
            </span>
            {index < steps.length - 1 && <div className="w-4 h-px bg-gray-300 ml-4" />}
          </div>
        );
      })}
    </div>
  );
};